import config from "../../config/environment.js";

// Export entity configuration for use in routes
export const reportByDateAndDniEntity = {
  friendlyPath: "inspecciones",
  path: config.endpoints.reportDateAndDni,
};
